import type { PartySlug } from '@mixwire/contracts';

/** sessionStorage key for the bearer token a device earns by passing the passkey check. */
export const suggesterTokenKey = (slug: PartySlug): string => `mixwire-suggester-token:${slug}`;
